import { z } from 'zod';

export const LicenseSchema = () => {
	return z.object({
		__typename: z.literal('License').optional(),

		// Editable Fields
		licenseNumber_V: z.string().nullish(), // ID
		typeValue_VId: z.string().nullish(), // Licensing Authority (Editable)
		expirationDate_V: z.string().nullish(),
		licenseStatus_V: z.string().nullish(),

		// Read-Only / Static Fields
		bestStateLicense_V: z.boolean().nullish(),
		body_V: z.string().nullish(),
		collabAgreeRequired_V: z.string().nullish(),
		comprehensivePrescriptiveAuthority_V: z.string().nullish(),
		comprehensiveSampleEligibility_V: z.string().nullish(),
		ctrlSubstancePrescriptive_V: z.string().nullish(),
		ctrlSubstanceSample_V: z.string().nullish(),
		deaBusinessActivityCode_V: z.string().nullish(),
		deaPaymentIndicator_V: z.string().nullish(),
		drugSchedule_V: z.string().nullish(),
		gracePeriod_V: z.string().nullish(),
		licenseCertification_V: z.string().nullish(),
		licenseDegree_V: z.string().nullish(),
		licenseEligibility_V: z.string().nullish(),
		licenseStatusCondition_V: z.string().nullish(),
		licenseSubtype_V: z.string().nullish(),
		rxaEligible_V: z.string().nullish(),
		sourceAddress_V: z.string().nullish(),
		type_V: z.string().nullish(), // License Type

		typeValue_V: z.string().nullish(),
		vid_V: z.string().nullish()
	});
};

export const LicensesSectionSchema = () => {
	return z.object({
		licenses: z.array(LicenseSchema()).nullish()
	});
};
